export default __webpack_public_path__ + "static/imageMatakul-d2eb3ee362fa289d69725039d7bb4ee1.png";